import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=2998eb5a&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2998eb5a')) {
      api.createRecord('2998eb5a', component.options)
    } else {
      api.reload('2998eb5a', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=2998eb5a&", function () {
      api.rerender('2998eb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/ProductCard.vue"
export default component.exports